var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAppleAppQr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 108,
    viewBox: "0 0 109 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 108,
    height: 108,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 10,
    width: 88,
    height: 88,
    fill: "url(#pattern0_29075_15442)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_29075_15442",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_29075_15442",
    transform: "scale(0.00182815)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_29075_15442",
    width: 547,
    height: 547,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiMAAAIjAQMAAADr5InyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAGUExURQAAAP///6XZn90AAAAJcEhZcwAADsMAAA7DAcdvqGQAAAMRSURBVHja7ZxBcuIwEEXblQVLboCPMkebHI2jODeYJQuXNcF2IwkcBsYt0lbe32DAfm69pKpLkhNZyO8wpTsfDiL7EI4iIfR6+FCeprQmlIOjEXmiYBe72PVSiziq5Ux5C2n00t18OEUvVWCS02R3PcWmFnFUC3ax+7PtevIi/IzujejPfFJ+6Zghax9JUxnTuKO0jijYxe7rvRywi931lGF+nx5qy3nc7pOUgwlFqqNgF7tbpWB3s3bDdIu5mXx+++v82j/fj7ZKaU0ojaNaPHnBLnaxa1ZLkqQHfFLez6/7/1/dej3FZkSH6rxgF7vYXU9pHNViR7lJth+wYmf5SUrjqJb6KNjF7uspYkI5OBpRjXbDF5nb73m+ELJOspTqKJ0JZcDu4rnYLenFppYP7BasxZfdLFP70IyziUbXm8bTp8WlcQaSP0BkQLGp5cNRLfXZHRyNyJMX7GJXtm33ukF8OZuQSElOHEwonSNKgIJd7GL3R9jNrp6mENnfiIXYPiSuKL1l2w9iQmkdURpHtWAXu9ity643L712kumTeTt5N6OG2GduTtQ721AaE4o4GhF2sbtVu1KdXU9efNnVjL3iZqUq9q3LipLWr7eTdJd7DUUcUWxGVJ/dFgoUKI4o+bOhyzn+cz8AChQoUKBsl6LnjZ2kiYf3EteCoEB5NUUEL+UoIngpRxGvI8oWgKbD9xmYZ7p0fnO6GlEVlNYRBbslKdgtScGuf0r0knyS/K8IXTPSPeEkbXIPKIuUDi9QoEBxTglLuUxYdL6QPBc0po+3gwIFChQom6UsJFm00vOO8TGk4739aShQoECBsi1KvrPcxdmEZp9RxvTZ7WwoQi3YxS52sfsdI7r+39FD3GAI8ds8t+veLijBEaUT7JajYLckBbslKaW9aJqFv/DVHpBmPaV1RJHqKNjF7lYp2P0eu7s4JViOPkR6sqJIdRTslqRgFwoUM0r+ZTKb0PlC0j6SR4TSRSMoUB6ltI4o9Y0Iu9h9tpabZJRLkjtdX1AfRRzV4mlENhR+X7CLXScUkb+crct4blmGMAAAAABJRU5ErkJggg=="
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppleAppQr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/apple-app-qr.f1eb2d97c423ab6eccb4e470bd707c16.svg";